// extracted by mini-css-extract-plugin
export var actionButton = "_c0-0";
export var attachmentLine = "_c0-1";
export var fileInput = "_c0-2";
export var fileUploadWrapper = "_c0-4";
export var footer = "_c0-3";
export var modalContent = "_c0-5";
export var paperclip = "_c0-6";
export var quillEditor = "_c0-7";